import { RoleModel } from '../../admin/role-management/role-model';

export class AuthTokenModel {
  id_token: string;
  access_token: string;
  refresh_token: string;
  user_name: string;
  error: boolean;
  error_message: string;
  app_version: string;
  app_environment: string;
  permissions: string[] = [];
  sso_user: boolean;
  session: string;
  challenge: string;
  challengeParams: { };
}
